import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import { scrub } from '@nu-art/ts-common';
import './Renderer_ProtocolTitle.scss';
import { ProtocolData } from '../../../_utils/ProtocolData/ProtocolData.js';
export class Renderer_ProtocolTitle extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.protocolData = ProtocolData.createNew(nextProps.protocolId);
        return state;
    }
    render() {
        if (!this.state.protocolData)
            return;
        const style = scrub({
            '--dp-color': this.state.protocolData.getColor(),
        });
        return _jsxs(LL_H_C, { className: 'protocol-title', style: style, children: [_jsx("div", { className: 'protocol-title__color' }), _jsx("div", { className: 'protocol-title__name', children: this.state.protocolData.getLabel() })] });
    }
}
//# sourceMappingURL=Renderer_ProtocolTitle.js.map